import React, { useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Stepper from "../components/stepper/Stepper";
import { useStepper } from "../components/stepper/context";
import { useAuth } from "../context/auth";
import PasswordChecklist from "react-password-checklist";
import circle from "../assets/svg/empty-circle.svg";
import ombre from "../assets/svg/ombre-circle.svg";
import "../index.scss";
import { navigate } from "@reach/router";

const Header = styled.h1`
  width: 70px;
  height: 24px;
  margin-top: 20px;
  margin-left: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
  text-align: center;
`;

const Title = styled.h1`
  height: 24px;
  margin-top: 20px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
  text-align: center;
`;

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const FormLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const Tips = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
  margin-top: 5px;
`;

const Errors = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #ff5c5c;
  margin-left: 40px;
  margin-top: 5px;
`;

const Text = styled.p`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #fffcf2;
  margin-left: 10px;
`;
const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 40vh;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const RadioBtn = styled.input`
  opacity: 0.1;
  border: 1px solid #fffcf2;
  box-sizing: border-box;
  &:checked {
    background: yellowgreen;
    border: 2px solid yellowgreen;
  }
`;

const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

const SvgImg3 = styled.img`
  border-radius: 50%;
  width: 14px;
  margin-right: 10px;
  margin-bottom: 10px;
`;

export default function Registration(props) {
  const [goSteps, setGoSteps] = useState(0);
  const completeFormStep = () => {
    setGoSteps((cur) => cur + 1);
    incrementCurrentStep();
  };
  const renderButton = () => {
    if (goSteps === 2) {
      return <NextBtn type="submit">Next</NextBtn>;
    } else {
      return (
        <NextBtn disabled={!isValid} type="button" onClick={completeFormStep}>
          Next
        </NextBtn>
      );
    }
  };
  const renderTitle = () => {
    if (goSteps === 0) {
      return <Title>Email</Title>;
    } else if (goSteps === 1) {
      return <Title>Password</Title>;
    } else {
      return <Title>Personal Information</Title>;
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const { incrementCurrentStep, decrementCurrentStep, resetStep } =
    useStepper();
  const { Register } = useAuth();
  const [checkPassword, setCheckPassword] = useState("");

  const onSubmit = (data) => {
    Register(data.email, data.password, data.fullName, data.displayName).then(
      () => {
        navigate("/add-trait");
        resetStep();
      }
    );
  };
  return (
    <>
      <div>
        <BackBtn>
          <i class="fa fa-ellipsis-h"></i>
        </BackBtn>
      </div>
      <div>
        <Header>Sign Up</Header>
      </div>
      <div>{renderTitle()}</div>
      <div></div>
      <div style={{ marginTop: "10px" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper>
            <Stepper.Steps>
              <Stepper.Step id="first">
                {goSteps === 0 && (
                  <>
                    <section>
                      <div>
                        <FormLabel>Email:</FormLabel>
                      </div>
                      <div className="d-flex justify-content-center">
                        <FormInput
                          {...register("email", {
                            required: true,
                            pattern: /^\S+@\S+$/,
                          })}
                          placeholder="Your email address"
                        />
                      </div>
                      {errors.email && (
                        <Errors>Please enter valid email address</Errors>
                      )}
                      <Tips>You will need to confirm email later.</Tips>
                    </section>
                  </>
                )}
              </Stepper.Step>
              <Stepper.Step id="second">
                {goSteps === 1 && (
                  <>
                    <section>
                      <div>
                        <FormLabel>Password:</FormLabel>
                      </div>
                      <div className="d-flex justify-content-center">
                        <FormInput
                          type="password"
                          {...register("password", {
                            required: true,
                            pattern: {
                              value:
                                /^(?=.*\d.*)(?=.*[a-zA-Z].*)(?=.*[!#\$%&\?].*).{7,}.+$/,
                              message: "invalid email address",
                            },
                            message: "Please enter password",
                            onChange: (e) => {
                              setCheckPassword(e.target.value);
                            },
                          })}
                          placeholder="Your password"
                        />
                      </div>
                      <div className="d-flex flex-row">
                        <div className="d-flex flex-column px-3 mt-3 mx-1">
                          <PasswordChecklist
                            rules={["minLength", "number"]}
                            minLength={8}
                            value={checkPassword}
                            messages={{
                              minLength: "8 characters minimum",
                              number: "One number",
                            }}
                            iconComponents={{
                              ValidIcon: <SvgImg3 src={ombre} />,
                              InvalidIcon: <SvgImg3 src={circle} />,
                            }}
                          />
                        </div>
                        <div className="d-flex flex-column px-3 mt-3">
                          <PasswordChecklist
                            rules={["specialChar", "capital"]}
                            minLength={5}
                            value={checkPassword}
                            messages={{
                              specialChar: "One symbol",
                              capital: "One capital",
                            }}
                            iconComponents={{
                              ValidIcon: <SvgImg3 src={ombre} />,
                              InvalidIcon: <SvgImg3 src={circle} />,
                            }}
                          />
                        </div>
                      </div>
                    </section>
                  </>
                )}
              </Stepper.Step>
              <Stepper.Step id="third">
                {goSteps === 2 && (
                  <>
                    <section>
                      <div>
                        <FormLabel>Full Name:</FormLabel>
                      </div>
                      <div className="d-flex justify-content-center">
                        <FormInput
                          {...register("fullName", {
                            required: true,
                            message: "Please enter full name",
                          })}
                          placeholder="Your full name"
                        />
                      </div>
                      {errors.fullName && (
                        <Errors>Please enter your full name</Errors>
                      )}
                      <div style={{ marginTop: "15px" }}>
                        <FormLabel>Display Name:</FormLabel>
                      </div>
                      <div className="d-flex justify-content-center">
                        <FormInput
                          {...register("displayName", {
                            required: true,
                            message: "Please enter display name",
                          })}
                          placeholder="Your display name"
                        />
                      </div>
                      {errors.displayName && (
                        <Errors>Please enter your display name</Errors>
                      )}
                      <Tips>
                        You will be able to adjust your display name in profile.
                      </Tips>
                    </section>
                  </>
                )}
              </Stepper.Step>
            </Stepper.Steps>
          </Stepper>
          {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            {renderButton()}
          </div>
        </form>
      </div>
    </>
  );
}
